import { render, staticRenderFns } from "./Hoods.vue?vue&type=template&id=824ac8dc&scoped=true&"
import script from "./Hoods.vue?vue&type=script&lang=js&"
export * from "./Hoods.vue?vue&type=script&lang=js&"
import style0 from "./Hoods.vue?vue&type=style&index=0&id=824ac8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824ac8dc",
  null
  
)

export default component.exports